export function setTrixContentAnchorTargets() {
  document.querySelectorAll('.trix-content a').forEach(function (anchor) {
    anchor.target = '_blank';
    anchor.rel = 'noopener';
  });
}
